import { FirebaseData } from "../../General/FirebaseData";
import { SupportedLanguages } from "../../../../libs/i18next/language";
import { TranslationData } from "../../General/TranslationData";
import { CustomFieldDataType } from "../../Company/Collections/CustomFieldDataType";
import { CustomFieldDataTypeHelper } from "../../Company/Collections/CustomFieldDataTypeHelper/CustomFieldDataTypeHelper";
import { CustomFieldRequiredFieldValuesToDisplay } from "to-be-removed/LocalData/Company/Collections/CompanyCustomFieldData";

export type CustomFieldDataOptionsStandardID = "systems" | "components";
export type CustomFieldDataOptions = {
  timeEnabled?: boolean;
  dateEnabled?: boolean;
  contractorAccess?: boolean;
  formula?: string;
  collectionID?: string;
  standardID?: string;
  customDataTypeID?: string;
  isMulti?: boolean;
  previewFiles?: boolean;
  hideParentReference?: boolean;
};

export class PropertyCustomFieldData extends FirebaseData {
  static getDefaultOptions(): CustomFieldDataOptions {
    return {
      timeEnabled: false,
      dateEnabled: true,
    };
  }

  dataType: CustomFieldDataTypeHelper<any> = CustomFieldDataType.TEXT;
  dataOptions: CustomFieldDataOptions = PropertyCustomFieldData.getDefaultOptions();

  standardLangCode: SupportedLanguages = SupportedLanguages.EN;
  name: TranslationData = new TranslationData();

  deprecated: boolean = false;

  requiredFieldValuesToDisplay: CustomFieldRequiredFieldValuesToDisplay = {};

  setup(data: any) {
    this.dataType = CustomFieldDataType.getTypeWithId(data.dataType);
    if (typeof data.dataOptions === "object") {
      this.dataOptions = {
        timeEnabled: typeof data.dataOptions.timeEnabled === "boolean" ? data.dataOptions.timeEnabled : false,
        dateEnabled: typeof data.dataOptions.dateEnabled === "boolean" ? data.dataOptions.dateEnabled : true,
        contractorAccess: typeof data.dataOptions.contractorAccess === "boolean" ? data.dataOptions.contractorAccess : undefined,
        formula: typeof data.dataOptions.formula === "string" ? data.dataOptions.formula : undefined,
        collectionID: typeof data.dataOptions.collectionID === "string" ? data.dataOptions.collectionID : undefined,
        standardID: typeof data.dataOptions.standardID === "string" ? data.dataOptions.standardID : undefined,
        customDataTypeID: typeof data.dataOptions.customDataTypeID === "string" ? data.dataOptions.customDataTypeID : undefined,
        isMulti: typeof data.dataOptions.isMulti === "boolean" ? data.dataOptions.isMulti : undefined,
        previewFiles: typeof data.dataOptions.previewFiles === "boolean" ? data.dataOptions.previewFiles : undefined,
        hideParentReference: typeof data.dataOptions.hideParentReference === "boolean" ? data.dataOptions.hideParentReference : undefined,
      };
    }
    this.requiredFieldValuesToDisplay = typeof data.requiredFieldValuesToDisplay === "object" ? data.requiredFieldValuesToDisplay : {};

    this.standardLangCode = SupportedLanguages.getLanguageWithCode(data.standardLangCode);
    this.name.setup(data.name, this.standardLangCode);

    this.deprecated = typeof data.deprecated === "boolean" ? data.deprecated : false;

    super.setup(data);
  }
}

